module.exports = __webpack_public_path__ + "static/media/WhatIfIHaveMoreQuestions.9d8221ae.png";